import type { SegmentT } from '@mentimeter/http-clients';
import type { ChoicesT, EmptyT } from '@mentimeter/question-modules-types';
import {
  usePreviewResultsIterator,
  getChoicesPreviewResultsIteration,
} from '@mentimeter/slides-preview-results';
import { useCallback } from 'react';

const EMPTY_RESULTS: EmptyT = {
  respondents: 0,
  type: 'empty',
  results: [],
  isPlaceholderResults: true,
};

interface UseChoicePreviewResultsProps {
  isPreviewResultsEnabled: boolean;
  choices: Array<{
    id: number;
    label: string;
  }>;
  segments: SegmentT[] | undefined;
}

export const useChoicePreviewResultsLegacy = ({
  isPreviewResultsEnabled,
  choices,
  segments,
}: UseChoicePreviewResultsProps): ChoicesT | EmptyT => {
  const getNextResults = useCallback(
    (iteration: number, previous: ChoicesT | undefined) => {
      if (previous === undefined || previous.type === 'choices') {
        return getChoicesPreviewResultsIteration({
          iteration,
          previous,
          extras: {
            type: 'choices',
            choices,
            segments,
          },
        });
      } else {
        return undefined;
      }
    },
    [choices, segments],
  );

  return (
    usePreviewResultsIterator(isPreviewResultsEnabled, getNextResults) ??
    EMPTY_RESULTS
  );
};
